import React, { Fragment, useRef, useEffect } from 'react';
import { RouteComponentProps, Link } from 'react-router-dom';
import { useAsync } from '@tiger/hooks';
import { Breadcrumb } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import _ from 'lodash';
import Loading from 'components/Loading';
import ErrorBox from 'components/ErrorBox';
import URL from 'utils/URL';

import store from '../../store';

import './style.scss';

const Search: React.FC<RouteComponentProps> = props => {
    const keyword = decodeURIComponent(URL.current().query.keyword as string);
    const [state, getData] = useAsync(() => store.getSearchContent(keyword));
    const inputRef = useRef(null);

    const reg = /<\/?.+?\/?>/g; // 清除标签（只获取内容）
    // 转译特殊符号
    let _keyword = keyword.replace(/\$|\+|\.|\^|\?|\*|\[|\]|\{|\}|\(|\)/g, function(txt) {
        return `\\${txt}`;
    });
    const panter = new RegExp(_keyword as string, 'gi'); // 匹配关键字

    const goSearch = () => {
        const value = (inputRef.current as any).value;

        if (value) {
            props.history.push(`/help/search?keyword=${encodeURIComponent(value)}`);
        }
    };

    useEffect(() => {
        if (keyword) {
            getData();
        }
        // eslint-disable-next-line
    }, [keyword]);

    const handleInput = e => {
        if (e.nativeEvent.keyCode === 13) {
            goSearch();
        }
    };

    function render() {
        if (state.loading) {
            return <Loading tip={'loading...'} />;
        }

        if (state.error) {
            return <ErrorBox error={state.error} onClick={getData} />;
        }

        if (!state.data.data.items.length) {
            return (
                <h2>
                    Your search <span className="highlight">{keyword}</span> did not match any documents.
                </h2>
            );
        }

        const length = _.flattenDeep(state.data.data.items.map(el => el.children)).length;

        return (
            <Fragment>
                <h2>
                    {`About ${length} results，showing results for`} <span className="highlight">{keyword}</span>
                </h2>
                {state.data.data.items.map(items => {
                    return (
                        <div className="result-content" key={items.link_code}>
                            {!items.children.length && (
                                <h4>
                                    <Link to={`/help/${items.link_code}`}>
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: items.title.replace(panter, function(txt) {
                                                    return `<span style="color: red">${txt}</span>`;
                                                })
                                            }}></div>
                                    </Link>
                                </h4>
                            )}
                            {items.children.map((subItem, index) => {
                                return (
                                    <div key={index} className="content-item-box">
                                        <h5>
                                            <Link to={`/help/${items.link_code}/${subItem.id}`}>
                                                <div
                                                    dangerouslySetInnerHTML={{
                                                        __html: `${items.title}-${subItem.title}`.replace(
                                                            panter,
                                                            function(txt) {
                                                                return `<span style="color: red">${txt}</span>`;
                                                            }
                                                        )
                                                    }}></div>
                                            </Link>
                                        </h5>
                                        {!!subItem.content && (
                                            <div
                                                className="content-item"
                                                dangerouslySetInnerHTML={{
                                                    __html: subItem.content
                                                        .replace(reg, '')
                                                        .slice(0, 200)
                                                        .replace(panter, txt => {
                                                            return `<span style="color: red">${txt}</span>`;
                                                        })
                                                }}></div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    );
                })}
            </Fragment>
        );
    }

    return (
        <div className="search-root">
            <Helmet>
                <title>Search {keyword} - Help</title>
            </Helmet>
            <div className="help-common-top">
                <div className="site-main">
                    <div className="d-flex">
                        <Breadcrumb className="search-breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/help">Help</Link>
                            </li>
                            <Breadcrumb.Item active>Search Results</Breadcrumb.Item>
                        </Breadcrumb>
                        <div className="search-input">
                            <input className="search" placeholder="Search" ref={inputRef} onKeyPress={handleInput} />
                            <div className="search-icon" onClick={goSearch}></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="help-main site-main">
                <div className="search-content">{render()}</div>
            </div>
        </div>
    );
};

export default Search;
